import { Injectable, transition } from '@angular/core';
import { HttpClientJsonpModule, HttpClient, HttpErrorResponse, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ResponseContentType } from '@angular/http';
import { Headers } from '@angular/http'
const apiUrl = "rutaejemplo";

@Injectable()
export class EjemploService {

  private host: any = apiUrl;
  private headerPost: any;
  private headerGet: any;

  constructor(private httpClient: HttpClient) {
    this.headerPost = new Headers({ 'Content-Type': 'application/json', "method": "post" });
    this.headerGet = new Headers({ 'Content-Type': 'application/json', "method": "get" });
  }

  /* Servicios*/ 



}




// WEBPACK FOOTER //
// ./src/app/services/ejemplo.service.ts